module.exports = __webpack_public_path__ + "static/media/item_36_5.4162388f.jpg";